import { useMemo } from 'react'

export interface CssHandles {
  [key: string]: string
}

export const useCssHandles = (handles: readonly string[]): CssHandles => {
  return useMemo(() => {
    const cssHandles: CssHandles = {}
    handles.forEach(handle => {
      cssHandles[handle] = `baterpower-${handle}`
    })
    return cssHandles
  }, [handles])
}
